export function formatTextWithNoDiacritics(inputText: string): string {
    if(!inputText) return '';
    return inputText.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
}